import JudasConstant from '@Pages/coupon/constants/JudasConstant'
import { ModuleLxType, moduleTracker } from '@/common/lx'
import commonRequest from '@/common/api'
import {
  CouponsRequest,
  MyCouponsExchangeRequest,
  OrderCouponsExchangeRequest,
  OrderCouponsRequest,
  PositionSwitchRequest,
  PositionRequest,
  CouponUpgradeRequest,
  CouponDowngradeRequest,
} from './model'

const indicatorModule = Mach.requireModule('ActivityIndicator')
const Toast = Mach.requireModule('Toast')

export const TypeRequest = {
  MY_COUPONS: 0, // 未使用
  HISTORY_COUPONS_USED: 1, // 已使用
  HISTORY_COUPONS_EXPIRED: 2, // 已过期
  HISTORY_COUPONS_INVAILD: 5, // 已失效
}

export const URL = {
  COUPON_LIST_REQ_URL: 'v1/userinfo/my/coupon',
  ORDER_COUPON_LIST_REQ_URL: 'v1/order/getCouponList',
  MY_COUPONS_EXCHANGE: 'v1/userinfo/my/exchange',
  ORDER_COUPONS_EXCHANGE: 'v1/order/couponExchangeApply',
  POSITION_COUPONS_SWITCH: 'v1/channel/version/switch',
  POSITION_COUPONS_RESOURCE: 'v1/channel/launch/task/list',
  MY_COUPONS_USE_LINK: 'v1/coupon/mycoupon/getUseCouponLinkUrl',
  COUPON_UPGRADE_URL: 'interests/upgraderelation/upgrade',
  COUPON_DOWNGRADE_URL: 'interests/upgraderelation/upgradereverse',
}

/**
 * 我的/历史-优惠券列表接口请求
 * @param orderRequest
 */
export async function couponListRequest (couponsRequest: CouponsRequest): Promise<any> {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.COUPON_LIST_REQ_URL,
      data: {
        ...couponsRequest,
      },
      method: 'POST',
    })
    indicatorModule.hideLoading()
    if (requestData?.data) return requestData?.data
    else {
      const showMessage = requestData?.message
      throw showMessage
    }
  } catch (error: any) {
    indicatorModule.hideLoading()
    if (error && error.message) {
      const showMessage = error?.message
      throw showMessage
    } else throw 'error'
  }
}

/**
 * 提单-优惠券列表接口请求
 * @param orderRequest
 */
export async function orderCouponListRequest (orderCouponListRequest: OrderCouponsRequest): Promise<any> {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.ORDER_COUPON_LIST_REQ_URL,
      data: {
        ...orderCouponListRequest,
      },
      method: 'POST',
    })
    indicatorModule.hideLoading()
    if (requestData?.data) return requestData?.data
    else {
      const showMessage = requestData?.message
      throw showMessage
    }
  } catch (error: any) {
    indicatorModule.hideLoading()
    if (error?.code === 1001) {
      Toast.show(error?.message, 2)
      return error?.data
    } else if (error && error.message) {
      const showMessage = error?.message
      Toast.show(showMessage, 2)
      throw showMessage
    } else throw 'error'
  }
}

/**
 * 我的券列表页-券兑换接口
 * @param orderRequest
 */
export async function myCouponExchange (exchangeCouponsRequest: MyCouponsExchangeRequest): Promise<any> {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.MY_COUPONS_EXCHANGE,
      data: {
        ...exchangeCouponsRequest,
      },
      method: 'POST',
    })
    indicatorModule.hideLoading()
    if (requestData?.coupons || requestData?.data) return requestData?.coupons || (requestData?.data ? [requestData?.data] : [])
    else {
      const showMessage = requestData?.msg
      // 失败状态埋点
      moduleTracker({
        type: ModuleLxType.MV,
        cid: JudasConstant.MY_COUPON_PROMO_CID,
        bid: JudasConstant.COUPON_PROMO_FAIL_MV,
        valLab: { remind_reason: requestData?.code },
      })
      throw showMessage
    }
  } catch (error: any) {
    indicatorModule.hideLoading()
    if (error && error.code) {
      const showMessage = error?.msg
      // 失败状态埋点
      moduleTracker({
        type: ModuleLxType.MV,
        cid: JudasConstant.MY_COUPON_PROMO_CID,
        bid: JudasConstant.COUPON_PROMO_FAIL_MV,
        valLab: { remind_reason: error?.code },
      })
      throw showMessage
    } else {
      // 非接口服务导致的异常上报-1
      moduleTracker({
        type: ModuleLxType.MV,
        cid: JudasConstant.MY_COUPON_PROMO_CID,
        bid: JudasConstant.COUPON_PROMO_FAIL_MV,
        valLab: { remind_reason: -1 },
      })
      throw 'error'
    }
  }
}

/**
 * 提单券列表页-券兑换接口
 * @param orderRequest
 */
export async function orderCouponExchange (exchangeCouponsRequest: OrderCouponsExchangeRequest): Promise<any> {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.ORDER_COUPONS_EXCHANGE,
      data: {
        ...exchangeCouponsRequest,
      },
      method: 'POST',
    })
    indicatorModule.hideLoading()
    return requestData
  } catch (error: any) {
    indicatorModule.hideLoading()
    if (error && error.code) return error
    else throw 'error'
  }
}

// 获取跳转地址
export const getJumpToUrl = async ({
  couponViewId,
  longitude,
  latitude,
  actualLatitude,
  actualLongitude,
  defaultUseCouponLink,
}: {
  couponViewId: string
  longitude: number
  latitude: number
  actualLatitude: number
  actualLongitude: number
  defaultUseCouponLink: string
}) => {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.MY_COUPONS_USE_LINK,
      data: {
        couponViewId,
        commonParam: {
          longitude,
          latitude,
          actualLatitude,
          actualLongitude,
        },
      },
      method: 'POST',
    })
    indicatorModule.hideLoading()
    if (requestData?.code === 0) return requestData?.data?.linkUrl || defaultUseCouponLink
    return defaultUseCouponLink
  } catch (error: any) {
    indicatorModule.hideLoading()
    return defaultUseCouponLink
  }
}

/**
 * 优惠券资源位降级
 * @param commonParams
 * **/
export async function bannerDowngradeSwitch (commonParams: PositionSwitchRequest): Promise<any> {
  try {
    // indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.POSITION_COUPONS_SWITCH,
      data: {
        ...commonParams,
      },
      method: 'POST',
    })
    // indicatorModule.hideLoading()
    return requestData
  } catch (error: any) {
    // indicatorModule.hideLoading()
    if (error && error.code) return error
    else throw 'error'
  }
}

/**
 * 资源位接口
 * **/
export async function getResourcePositionList (commonParams: PositionRequest): Promise<any> {
  try {
    // indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.POSITION_COUPONS_RESOURCE,
      data: {
        ...commonParams,
      },
      method: 'POST',
    })
    // indicatorModule.hideLoading()
    return requestData
  } catch (error: any) {
    // indicatorModule.hideLoading()
    if (error && error.code) return error
    else throw 'error'
  }
}

/**
 * 我的/提单券列表-券膨胀接口
 * @param upgradeParams
 */
export async function couponUpgrade (upgradeParams: CouponUpgradeRequest): Promise<any> {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.COUPON_UPGRADE_URL,
      data: {
        ...upgradeParams,
      },
      method: 'POST',
    })
    return requestData
  } catch (error: any) {
    if (error && error.code) return error
    else throw 'error'
  } finally {
    indicatorModule.hideLoading()
  }
}

/**
 * 我的/提单券列表-券逆膨接口
 * @param downgradeParams
 */
export async function couponDowngrade (downgradeParams: CouponDowngradeRequest): Promise<any> {
  try {
    indicatorModule.showLoading()
    const requestData = await commonRequest({
      url: URL.COUPON_DOWNGRADE_URL,
      data: {
        ...downgradeParams,
      },
      method: 'POST',
    })
    return requestData
  } catch (error: any) {
    if (error && error.code) throw error
    else throw 'error'
  } finally {
    indicatorModule.hideLoading()
  }
}
